<div>
    <div class="listheader">{{ ::pickerHeader }} ({{ listPicker.pickerItemCount() }})</div>
    <div class="tools" ng-if="listPicker.searchable">
        <input type="search" placeholder="{{ ::pickerSearchPlaceholder }}" ng-model="listPicker.pickerSearch" />
        <c-drop-down-menu ng-if="listPicker.menuitems" menu-items="listPicker.menuitems" menu-callback="listPicker.menuCallback"></c-drop-down-menu>
    </div>
    <div class="list">
        <ul class="picker">
            <li ng-repeat="item in listPicker.uncheckedItems" ng-click="selectItem(item.id)">
                <div class="list-item">
                    <c-checkbox class="left" checked="false"></c-checkbox>
                    <span ng-bind-html="item.text | cHighlight: listPicker.highlight"></span>
                    <span ng-if="item.badgeText" class="badge" ng-bind-html="item.badgeText | cHighlight: listPicker.highlight"></span>
                </div>
                <div ng-if="listPicker.getAdditionalInfo(item.id)" ng-repeat="ainfo in listPicker.getAdditionalInfo(item.id)" class="info-item">
                    <span ng-bind-html="ainfo.text | cHighlight: listPicker.highlight"></span>
                </div>
            </li>
        </ul>
        <centuri-scroll-monitor ng-if="isPaged" enter-viewport="listPicker.loadNextPage()" offset="100" done-loading="listPicker.doneLoading()"></centuri-scroll-monitor>
    </div>
</div>

<div>
    <div class="listheader">{{ ::viewerHeader }} ({{ listPicker.viewerItemCount() }})</div>
    <div class="tools" ng-if="listPicker.searchable">
        <input type="search" placeholder="{{ ::viewerSearchPlaceholder }}" ng-model="listPicker.viewerSearch"/>
    </div>
    <div class="list" ng-class="{'invalid': !listPicker.validate()}">
        <ul class="viewer">
            <li ng-repeat="item in listPicker.checkedItems | orderBy:listPicker.viewerOrderBy" ng-if="listPicker.activeViewerFilter(item)" ng-click="deselectItem(item.id)">
                <div ng-class="{ 'list-item': true }">
                    <c-checkbox class="left" checked="true"></c-checkbox>

                    <span ng-bind-html="item.text | cHighlight: listPicker.viewerHighlight"></span>
                    <span ng-if="item.badgeText" class="badge" ng-bind-html="item.badgeText | cHighlight: listPicker.viewerHighlight"></span>
                </div>
                <div ng-if="listPicker.getAdditionalInfo(item.id)" ng-repeat="ainfo in listPicker.getAdditionalInfo(item.id)" class="info-item">
                    <span ng-bind-html="ainfo.text | cHighlight: listPicker.viewerHighlight"></span>
                </div>
            </li>
        </ul>
    </div>
</div>
<div class="validation-message" ng-show="!listPicker.validate()">Välj minst en</div>
